import React, { useState } from "react";
import "./AboutSection.scss";

// Función para renderizar saltos de línea
const renderDescriptionWithBreaks = (text) => {
  return text.split("\n").map((line, index) => (
    <React.Fragment key={index}>
      {line}
      <br />
    </React.Fragment>
  ));
};

// Componente del Modal con Diseño Mejorado
const Modal = ({ show, onClose, coach }) => {
  if (!show) return null; // No renderiza nada si no está visible

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="close-btn" onClick={onClose}>
          &times;
        </button>
        <div className="modal-body">
          {/* Columna de Texto */}
          <div className="modal-text">
            <h2>{coach.name}</h2>
            <p className="modal-role">{coach.role}</p>
            <p>{renderDescriptionWithBreaks(coach.description)}</p>
            <div className="modal-contact">
              <a href={`tel:${coach.phoneLink}`}>{coach.phone}</a>
              <a href={`mailto:${coach.email}`}>{coach.email}</a>
              <a href={coach.instagram} target="_blank" rel="noreferrer">
                Instagram
              </a>
            </div>
          </div>
          {/* Columna de Imagen */}
          <div className="modal-image">
            <img src={coach.image} alt={coach.name} />
            <a href="#transformacion">Mi transformación</a>
          </div>
        </div>
      </div>
    </div>
  );
};

const AboutSection = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedCoach, setSelectedCoach] = useState(null);

  const coachs = {
    karla: {
      name: "Karla Rentería",
      role: "Fundadora & coach Mentfull",
      description: `Soy Lic. en comunicación y Entrenadora certificada por wabba internacional y quiero ayudarte en este camino para que puedas disfrutar de este proceso, yo comencé este estilo de vida cuando entré a la universidad, ya que tuve síndrome de ovario poliquístico y para mi era muy complicado bajar de peso y verme como yo quería, tenía problemas de autoestima, lo que comenzó siendo por problemas de salud y un rechazo hacia mi físico, terminó siendo parte fundamental de mi vida y un hábito, fue hasta que comencé a disfrutar proceso e ir un día a la vez cuando vi resultados sostenibles y ahora no se trataba de solo cambiar el físico, resultó ser un cambio mental, emocional y espiritual. \n\nQuiero ayudarte a forjar disciplina, constancia, confianza y un cambio integral, no solo a nivel físico.`,
      image: "/assets/images/karlaThumb.png",
      instagram: "https://www.instagram.com/karlarenteriam/",
      email: "contacto@mentfull.com",
      phone: "+52 443 119 7376",
      phoneLink: "+524431197376",
    },
    xany: {
      name: "Xany Naranjo",
      role: "Fundadora & coach Mentfull",
      description: `Empecé mi vida fitness a los 18 años, después de haber pasado por una etapa con extrema dismorfia corporal y autoexigencia hacia mi físico, queriendo lucir siempre “perfecta” y siendo la delgadez mi único objetivo. A los 18 me inscribí a mi primer gimnasio pero al principio me sentía totalmente perdida y siempre sufriría pensando que los demás me estarían juzgando por no saber nada, por lo que empecé a pedir ayuda a entrenadores para aprender lo básico y mejorar mis técnicas y posteriormente decidí certificarme en entrenamiento especializado en mujeres y entrenamiento enfocado en glúteo; principalmente para aplicar estos conocimientos en mí. Conforme continuaba mi camino fitness, aumentó mi conocimiento, experiencia y aprendí cosas que me hubieran gustado saber cuando recién inicié y comencé a compartirlo con más personas, certificándome en entrenamiento personal y estudiando nutrición, especializándome en nutrición deportiva. \n\nQuiero compartir todo esto CONTIGO.`,
      image: "/assets/images/xanyThumb.png",
      instagram: "https://www.instagram.com/xanynaranjo/",
      email: "contacto@mentfull.com",
      phone: "+52 443 119 7376",
      phoneLink: "+524431197376",
    },
  };

  const handleOpenModal = (coachKey) => {
    setSelectedCoach(coachs[coachKey]);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedCoach(null);
  };

  return (
    <section id="nosotras" className="about-section">
      {/* Contenedor principal */}
      <div className="contenedor-nosotras">
        <div className="cuerpo-nosotras">
          <img src="/assets/images/imgTeam.png" alt="Equipo Mentfull" />
          <div className="contenido-nosotras">
            <h2>
              Balance entre cuerpo y mente <br />
              <span> Tu cuerpo debe conectar con tu mente...</span>
            </h2>
            <p>
              Además de grandes amigas; somos dos entrenadoras certificadas y
              apasionadas por la vida fitness. Queremos compartir nuestro
              conocimiento para ayudar a más personas a encontrar su propio
              camino hacia la disciplina y lograr un cambio integral.
              <br />
              <br />
              Buscamos ser un medio influyente para crear espacios de reflexión
              y contribuir al mejoramiento de la salud y condición física de
              nuestros usuarios.
            </p>
          </div>
        </div>
      </div>

      {/* Tarjetas de Coach */}
      <div className="cards-bio">
        <div className="card-bio">
          <img src="/assets/images/karlaThumb.png" alt="Karla Renteria" />
          <div className="descr-bio">
            <h2>Karla Rentería</h2>
            <p>{coachs.karla.role}</p>
            <button
              className="btn-accion"
              onClick={() => handleOpenModal("karla")}
            >
              Conoce a Karla
            </button>
          </div>
        </div>

        <div className="card-bio">
          <img src="/assets/images/xanyThumb.png" alt="Xany Naranjo" />
          <div className="descr-bio">
            <h2>Xany Naranjo</h2>
            <p>{coachs.xany.role}</p>
            <button
              className="btn-accion"
              onClick={() => handleOpenModal("xany")}
            >
              Conoce a Xany
            </button>
          </div>
        </div>
      </div>

      <div className="cta-nosotras">
        <h2>
          Nuestra misión es ayudarte a encontrar esa conexión entre cuerpo,
          mente y alma para descubrir el poder de tu
          <br />
          <br />
          <span>
            <img src="/assets/images/stars.png" alt="mentfull" /> magia interna{" "}
            <img src="/assets/images/stars.png" alt="mentfull" />
          </span>
        </h2>
      </div>

      {/* Modal */}
      <Modal
        show={showModal}
        onClose={handleCloseModal}
        coach={selectedCoach}
      />
    </section>
  );
};

export default AboutSection;
